export const environment: Config = {
    production: true,
    user_id_space_replacement_character: '',
    show_warnings: false,
    show_errors: true,
    pst_version: '',
    pst_serial_number: '',
    translated_label_login_error: 'Logon error...check username and password and try again.',
    translated_label_license_expired: 'Logon error...The license for this software has expired. Contact your AP support representative for assistance.',
    translated_label_ssogoogle: 'Login with Google',
    translated_label_ssomicrosoft: 'Login with Microsoft',
    translated_label_ssomicrosoftlive: 'Login with Microsoft Live',
    service_address: '',
    backup_service_address: '',
    discover_api_base_url: '',
    solr_poll_interval_seconds: 10,
    default_domain: '',
    virtual_directory: '',
    merlin_base_url: 'https://discover.enpscloud.com',
    merlin_media_base_url: 'https://mapi.associatedpress.com/v1/items',
    open_ai_api_key: '',
    froala_key: '0BA3jA9A8E5A4A5G5A3bHIMFF1EWBXIJb1BZLZFh1i1MXQLjE4C3F3C2B4D6B5E3D3D2==',
};
